import type { GetStaticPropsContext } from 'next';

import { DEFAULT_LANGUAGE } from '~/features/internationalization/languages';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { getPage } from '~/features/page/controllers/get-page';
import { ReimbursementPage } from '~/features/reimbursement/components/reimbursement-page';

type GetReimbursedPageProps = {
  page: Awaited<ReturnType<typeof getPage>>;
};

export default function GetReimbursedPage({ page }: GetReimbursedPageProps) {
  return (
    <>
      <PageHead page={page} />
      <PageLayout withoutVerticalPadding>
        <ReimbursementPage />
      </PageLayout>
    </>
  );
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  if (locale !== DEFAULT_LANGUAGE) {
    return {
      notFound: true,
    };
  }

  const page = await getPage('/get-reimbursed');

  return {
    props: {
      page,
    },
  };
}
